import { Validator } from '@vista-digital/validator';
import { defaultFilmActorsDisplayText } from '../../actors/types/display-text';
import { defaultFilmClassificationDescriptionDisplayText } from '../../classification-description/types/display-text';
import { defaultFilmDirectorsDisplayText } from '../../directors/types/display-text';
import { defaultFilmGenresDisplayText } from '../../genres/types/display-text';
import { defaultFilmReleaseDateDisplayText } from '../../release-date/types/display-text';
import { defaultFilmRuntimeDisplayText } from '../../runtime/types/display-text';
import { defaultFilmSynopsisDisplayText } from '../../synopsis/types/display-text';
export const defaultFilmSummaryDisplayText = {
    directorsLabel: defaultFilmDirectorsDisplayText.label,
    actorsLabel: defaultFilmActorsDisplayText.label,
    synopsisLabel: defaultFilmSynopsisDisplayText.label,
    runtimeLabel: defaultFilmRuntimeDisplayText.label,
    releaseDateLabel: defaultFilmReleaseDateDisplayText.label,
    releaseDateFormat: defaultFilmReleaseDateDisplayText.format,
    classificationDescriptionLabel: defaultFilmClassificationDescriptionDisplayText.label,
    genresLabel: defaultFilmGenresDisplayText.label,
    advanceBookingPeriodNotificationFormat: 'Tickets on sale at select cinemas from ${startsAt|d|Do of MMMM, h:mm A}.',
    advanceBookingPeriodTodayNotificationFormat: 'Tickets on sale at select cinemas today from ${startsAt|d|h:mm A}.'
};
export const filmSummaryDisplayTextValidatorSchema = {
    directorsLabel: Validator.nonEmptyString,
    actorsLabel: Validator.nonEmptyString,
    synopsisLabel: Validator.nonEmptyString,
    runtimeLabel: Validator.nonEmptyString,
    releaseDateLabel: Validator.nonEmptyString,
    releaseDateFormat: Validator.nonEmptyString,
    classificationDescriptionLabel: Validator.nonEmptyString,
    genresLabel: Validator.nonEmptyString,
    advanceBookingPeriodNotificationFormat: Validator.nonEmptyString,
    advanceBookingPeriodTodayNotificationFormat: Validator.nonEmptyString
};
export const filmSummaryDisplayTextValidator = Validator.object(filmSummaryDisplayTextValidatorSchema);
//# sourceMappingURL=display-text.js.map